import { CustomerType } from '@repo/common';
import { Badge } from '@repo/shadcn';

type PaymentStatusBadgeProps = {
    value?: string;
};

export const CustomerTypeBadge = ({ value }: PaymentStatusBadgeProps) => {
    if (value === CustomerType.WHOLESALE) {
        return (
            <Badge
                className="bg-blue-700 uppercase text-white transition-all duration-150 hover:bg-blue-800 dark:bg-blue-800 dark:hover:bg-blue-900"
                variant={'secondary'}
            >
                {value}
            </Badge>
        );
    }

    //   if (value === "rejected") {
    //     return (
    //       <Badge
    //         className="uppercase bg-red-500 text-white dark:bg-red-600"
    //         variant={"secondary"}
    //       >
    //         {value}
    //       </Badge>
    //     );
    //   }

    if (value === CustomerType.RETAIL) {
        return (
            <Badge
                className="bg-purple-500 uppercase text-white transition-all duration-150 hover:bg-purple-600 dark:bg-purple-600 dark:hover:bg-purple-700"
                variant={'secondary'}
            >
                {value}
            </Badge>
        );
    }

    return (
        <Badge
            className="bg-gray-500 uppercase text-white transition-all duration-150 hover:bg-gray-600 dark:bg-gray-600 dark:hover:bg-gray-700"
            variant={'secondary'}
        >
            {value}
        </Badge>
    );
};

CustomerTypeBadge.displayName = 'CustomerTypeBadge';
